import { AxiosResponse } from 'axios';
import { endPoints } from '../../utils/apiEndpoints';
import axios from '../../redux/axiosInterceptor'

export function requestSaveNomineeDetails(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.saveNomineeDetails,
    data,
  });
}

export function requestSkipNomineeDetails(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.skipNomineeDetails,
    data,
  });
}

export function requestFetchPincodeInfo(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'get',
    baseURL: endPoints.base,
    url: `${endPoints.getPincodeDetails}/${data.pincode}`,
  });
}
